/**
 * Clears the default size on product pages opened without a chosen variant,
 * and asks for a size before anything is added to the cart.
 * Loaded synchronously right after the variant picker so the default never paints.
 */
(() => {
  const PENDING_CLASS = 'size-pending';
  const ERROR_CLASS = 'size-pending--error';
  const BUY_SELECTOR = '.add-to-cart-button, .sticky-add-to-cart__button, .accelerated-checkout-block';

  const picker = document.querySelector('variant-picker[data-size-required]');
  const fieldset = picker?.querySelector('fieldset');
  const scope = picker?.closest('.shopify-section');
  if (!picker || !fieldset || !scope) return;

  const root = document.documentElement;
  const isPending = () => root.classList.contains(PENDING_CLASS);

  const clearDefault = () => {
    for (const input of fieldset.querySelectorAll('input:checked')) input.checked = false;
    root.classList.add(PENDING_CLASS);
  };

  const askForSize = () => {
    const status = scope.querySelector('[data-size-required-status]');
    const currentFieldset = scope.querySelector('variant-picker fieldset');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.classList.remove(ERROR_CLASS);
    void root.offsetWidth;
    root.classList.add(ERROR_CLASS);
    if (status) status.textContent = picker.dataset.sizeRequiredMessage || '';
    currentFieldset?.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    currentFieldset?.querySelector('input')?.focus({ preventScroll: true });
  };

  const blockUntilChosen = (event) => {
    if (!isPending() || !(event.target instanceof Element) || !scope.contains(event.target)) return;
    if (event.type === 'click' && !event.target.closest(BUY_SELECTOR)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    askForSize();
  };

  const markChosen = (event) => {
    if (!(event.target instanceof Element) || !scope.contains(event.target)) return;
    if (!event.target.closest('variant-picker')) return;

    root.classList.remove(PENDING_CLASS, ERROR_CLASS);
    const status = scope.querySelector('[data-size-required-status]');
    if (status) status.textContent = '';
  };

  clearDefault();
  // Window capture runs before the theme's delegated click handlers on the document.
  window.addEventListener('click', blockUntilChosen, true);
  window.addEventListener('submit', blockUntilChosen, true);
  window.addEventListener('change', markChosen, true);
})();
